import { render, staticRenderFns } from "./index.vue?vue&type=template&id=95149474"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95149474')) {
      api.createRecord('95149474', component.options)
    } else {
      api.reload('95149474', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=95149474", function () {
      api.rerender('95149474', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SearchBox/index.vue"
export default component.exports